import * as React from 'react'
import { minutesToTime } from '../helpers/time'
import { PartnerShape } from '../../api/api_data_types'

type PartnerRecordsTimesTableProps = {
  times: {
    [key: string]: {
      id?: number
      time: number
      worktype_id: number
      comment: string
      partner_time: boolean
    }
  }
  fieldNameFn: (field: string) => string
  availableWorktypes: [string, number][]
}

export default function PartnerRecordTimesTable(props: PartnerRecordsTimesTableProps) {
  const { times, availableWorktypes, fieldNameFn } = props

  const getWorktypeName = (worktypeId: number | string) => {
    const worktype = availableWorktypes.find(([_, id]) => id === parseInt(worktypeId.toString(), 10))
    return worktype ? worktype[0] : ''
  }

  return (
    <table className="table table-sm">
      <thead>
        <tr>
          <th>Tid</th>
          <th>Arbejdstype</th>
          <th>Beskrivelse</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(times).map(([key, time], index) => {
          return (
            <tr key={key}>
              <td>{minutesToTime(time.time || 0)}</td>
              <td>{getWorktypeName(time.worktype_id)}</td>
              <td>
                {time.comment}
                {time.id && <input type="hidden" name={fieldNameFn(`times_attributes][${index}][id`)} value={time.id} />}
                <input type="hidden" name={fieldNameFn(`times_attributes][${index}][time`)} value={time.time} />
                <input type="hidden" name={fieldNameFn(`times_attributes][${index}][comment`)} value={time.comment} />
                <input type="hidden" name={fieldNameFn(`times_attributes][${index}][worktype_id`)} value={time.worktype_id} />
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
